import { useCallback } from 'react'

import { useAnalytics } from '@/hooks/useAnalytics'

type Props = {
  active: boolean
  clickName?: string
  index: number
  isExtendedTab: boolean
  setSelectedTab: (index: number) => void
  title: string
}

export function TabTitle({ title, setSelectedTab, index, active, isExtendedTab, clickName }: Props): JSX.Element {
  const { trackUserEngagement } = useAnalytics()
  const onClick = useCallback(() => {
    setSelectedTab(index)
    clickName && trackUserEngagement({ click_name: clickName })
  }, [setSelectedTab, index, clickName, trackUserEngagement])

  return (
    <li className={`${active ? 'active' : ''} tab-title ${isExtendedTab ? 'mr-0' : 'mr-2'}`}>
      <button onClick={onClick}>{title}</button>
    </li>
  )
}

export default TabTitle
